<template>
  <div class="body">
      <VueShowdown id="aboutMe" :markdown="content" flavor="github"/>
  </div>
</template>

<script>
import Content from '../markdown/AboutMe.md'
  
export default {
  data() {
    return {
      content: '',
    }
  },
  mounted() {
    this.getMDFiles()
  },
  methods: {
    getMDFiles() {
      this.content = Content
    },
  },
  beforeCreate: function() {
    document.body.className = 'lightHeader';
  }
}
</script>

<style scoped lang="scss">
  .body{
    margin-top:200px;
    margin-bottom: 30px;
  }

  #aboutMe{
    padding: 0 40px;
  }

  @media (max-width: 960px) {
    .body{
      margin-top:100px;
      margin-bottom: 30px;
    }
  }
  
  @media (max-width: 600px) {
    .body{
      margin-top:10px;
    }
  }
</style>